<template>
  <base-page
    :class="[{ 'ps-is-active': loginModalActive }]"
    max-width="md:ps-max-w-md"
    class="ps-login"
    @dismiss="routerTo('ROUTE_LOGIN')"
  >
    <div
      slot="header"
      class="px-4 py-5 sm:px-8 sm:py-6 border-b border-gray-200 "
    >
      <h3 class="text-lg leading-6 font-medium text-gray-600">
        Sign In
      </h3>
    </div>
    <div class="ps-p-6 ps-py-8">
      <component :is="loginStrategyView" />
    </div>
  </base-page>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import BasePage from '@/components/BasePage'
import LoginStrategyLocal from '@/views/LoginStrategyLocal'

import { PROVIDER_LOCAL } from '@/common/constants'
import '@/icons/go'
import '@/icons/question-mark-circle'
import '@/icons/x'

export default {
  name: 'LoginStrategy',
  props: {
    loginMessage: String,
    version: String
  },
  components: {
    BasePage,
    LoginStrategyLocal
  },
  data() {
    return {
      loginModalActive: false
    }
  },
  computed: {
    ...mapState({
      provider: state => state.provider.slug
    }),
    opacity() {
      if (this.loginModalActive) {
        return 'ps-opacity-0'
      }
    },
    apiUrl() {
      return apiUrl()
    },
    loginStrategyView() {
      switch (this.provider) {
        case PROVIDER_LOCAL:
          return 'LoginStrategyLocal'
      }
    }
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    toggleLoginModal() {
      this.loginModalActive = !this.loginModalActive
    }
  }
}
</script>

<style lang="postcss" scoped>
.login-strategy {
  transition: transform 350ms ease;
  will-change: transform;
  transform: translateY(100%);
  &.is-active {
    transform: translateY(0);
  }
}
.login-dot {
  transform: translateX(-50%);
  transition: opacity 400ms ease;
  &:hover {
    & span {
      opacity: 1 !important;
    }
  }
}
.is-active .login-dot {
  /* transform: translateX(-50%) translateY(-120%); */
}

.ps-bubble {
  transition: transform 300ms ease;
}
.is-active .ps-bubble {
  transform: translateX(0) translateY(0);
}
.ps-bubble-delay-100 {
  transition-delay: 100ms;
  transform: translateX(10%) translateY(120%);
}
.ps-bubble-delay-200 {
  transition-delay: 300ms;
  transform: translateX(-70%) translateY(300%);
}
.ps-bubble-delay-300 {
  transition-delay: 400ms;
  transform: translateX(25%) translateY(100%);
}

.ps-decorators {
  bottom: 12rem !important;
}
</style>
